import { render, staticRenderFns } from "./HouseBLDocuments.vue?vue&type=template&id=306fb0f0&scoped=true&"
import script from "./HouseBLDocuments.vue?vue&type=script&lang=js&"
export * from "./HouseBLDocuments.vue?vue&type=script&lang=js&"
import style0 from "./HouseBLDocuments.vue?vue&type=style&index=0&id=306fb0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306fb0f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306fb0f0')) {
      api.createRecord('306fb0f0', component.options)
    } else {
      api.reload('306fb0f0', component.options)
    }
    module.hot.accept("./HouseBLDocuments.vue?vue&type=template&id=306fb0f0&scoped=true&", function () {
      api.rerender('306fb0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/houseBL/HouseBLDocuments.vue"
export default component.exports